/**
 * 存储上下文
 * 提供获取存储服务实例的工厂函数
 *
 * 核心功能：
 * 1. 使用依赖注入模式提供存储服务
 * 2. 分离接口和实现
 * 3. 便于测试和扩展
 */
import { StorageFactory } from '../factory.service.js';
// 存储服务实例
let documentStorageServiceInstance = null;
let pdfStorageServiceInstance = null;
let translationStorageServiceInstance = null;
/**
 * 注册文档存储服务
 * 使用依赖注入模式注册服务实例
 *
 * @param service 文档存储服务实例
 */
export function registerDocumentStorageService(service) {
    documentStorageServiceInstance = service;
}
/**
 * 注册PDF文档存储服务
 * @param service PDF文档存储服务实例
 */
export function registerPdfStorageService(service) {
    pdfStorageServiceInstance = service;
}
/**
 * 注册翻译存储服务
 * 使用依赖注入模式注册服务实例
 *
 * @param service 翻译存储服务实例
 */
export function registerTranslationStorageService(service) {
    translationStorageServiceInstance = service;
}
/**
 * 获取文档存储服务
 * 返回已注册的文档存储服务实例
 *
 * @returns 文档存储服务实例
 * @throws 如果服务未注册则抛出错误
 */
export function getDocumentStorageService() {
    if (!documentStorageServiceInstance) {
        throw new Error('Document storage service has not been registered');
    }
    return documentStorageServiceInstance;
}
/**
 * 获取PDF文档存储服务
 * @returns PDF文档存储服务实例
 * @throws 如果服务未注册则抛出错误
 */
export function getPdfStorageService() {
    if (!pdfStorageServiceInstance) {
        throw new Error('PDF storage service has not been registered');
    }
    return pdfStorageServiceInstance;
}
/**
 * 获取翻译存储服务
 * 返回已注册的翻译存储服务实例
 *
 * @returns 翻译存储服务实例
 * @throws 如果服务未注册则抛出错误
 */
export function getTranslationStorageService() {
    if (!translationStorageServiceInstance) {
        throw new Error('Translation storage service has not been registered');
    }
    return translationStorageServiceInstance;
}
/**
 * 为测试目的重置所有服务
 * 清除已注册的服务实例
 */
export function resetStorageServices() {
    documentStorageServiceInstance = null;
    pdfStorageServiceInstance = null;
    translationStorageServiceInstance = null;
}
/**
 * 根据文档标识符获取相应的统一文档存储服务。
 * 内部使用 StorageFactory 的逻辑，但通过上下文提供，以降低耦合。
 * @param identity 文档标识
 * @returns 实现了 IDocumentStorageService 接口的服务实例
 */
export function getServiceForIdentity(identity) {
    return StorageFactory.getServiceFor(identity);
}
//# sourceMappingURL=StorageContext.js.map